import { render, staticRenderFns } from "./AdvancesReceivedRefund.vue?vue&type=template&id=18e46653&scoped=true&"
import script from "./AdvancesReceivedRefund.vue?vue&type=script&lang=js&"
export * from "./AdvancesReceivedRefund.vue?vue&type=script&lang=js&"
import style0 from "./AdvancesReceivedRefund.vue?vue&type=style&index=0&id=18e46653&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e46653",
  null
  
)

export default component.exports